import type { ReactElement } from 'react';
import React from 'react';

import { Box } from '@zillow/constellation';
import { HeroImage, HeroImageNewCssComponent, OnsiteMessage } from '@zillow/zrs-cms-messaging';
import { isEmpty } from 'lodash';
import Head from 'next/head';

import { ompNewLaneProps } from '../../constants/newLane';
import { useGlobalStoreState } from '../../contexts/GlobalStoreProvider';
import { AllHopsPlacements } from '../../types/genericTypes';

const PLACEMENT_NAME = AllHopsPlacements.HOME_PAGE_HERO_IMAGE;
const triggerProps = ompNewLaneProps[PLACEMENT_NAME];

const OmpHeroImage: React.FC = (): ReactElement => {
    const { onsiteMessages } = useGlobalStoreState();
    if (!isEmpty(onsiteMessages)) {
        return (
            <Box data-testid="hops-hero-image-container">
                <OnsiteMessage
                    messageData={onsiteMessages}
                    placementName={PLACEMENT_NAME}
                    // eslint-disable-next-line max-len
                    // eslint-disable-next-line zillow/@typescript-eslint/no-unsafe-assignment, zillow/@typescript-eslint/naming-convention
                    supportedComponents={{ HeroImageNewCssComponent }}
                    triggerObject={triggerProps.triggerObject}
                    triggerLocation={triggerProps.triggerLocation}
                    triggerSource={triggerProps.triggerSource}
                    Head={Head}
                />
            </Box>
        );
    }

    return (
        <HeroImage
            mobileImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/375w_mobile.jpg"
            mobileImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/375w_mobile_2x.jpg"
            mobileWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/375w_mobile.webp"
            mobileWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/375w_mobile_2x.webp"
            tabletPortraitImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/768w_tablet_portrait.jpg"
            tabletPortraitImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/768w_tablet_portrait_2x.jpg"
            tabletPortraitWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/768w_tablet_portrait.webp"
            tabletPortraitWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/768w_tablet_portrait_2x.webp"
            tabletLandscapeImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1024w_tablet_landscape.jpg"
            tabletLandscapeImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1024w_tablet_landscape_2x.jpg"
            tabletLandscapeWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1024w_tablet_landscape.webp"
            tabletLandscapeWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1024w_tablet_landscape_2x.webp"
            desktopImg="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1920w.jpg"
            desktopImg2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1920w_2x.jpg"
            desktopWebp="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1920w.webp"
            desktopWebp2x="https://www.zillowstatic.com/bedrock/app/uploads/sites/5/2024/02/1920w_2x.webp"
            Head={Head}
        />
    );
};

export default OmpHeroImage;
